import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map } from "rxjs/operators";
import { IResponse } from "@bt/shared";
import {  UserModel } from "../models";
import { ApiService } from "./api.service";
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CourseService {

  public isNeedShowMap:boolean;
  constructor(private api: ApiService) {
    this.isNeedShowMap=false;
   }//, private $q: angular.IQService


  public uriBuilder(): string {
    return "api/course";
  }

  /// Получение данных для профиля пользователя  
  public getUser(): Promise<IResponse<UserModel>> {
    return this.api.get<UserModel>(this.uriBuilder() + "/me").toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/course.service.ts